import { render, staticRenderFns } from "./CrewLaborTemplateEdit.vue?vue&type=template&id=47e24217"
import script from "./CrewLaborTemplateEdit.vue?vue&type=script&lang=js"
export * from "./CrewLaborTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./CrewLaborTemplateEdit.vue?vue&type=style&index=0&id=47e24217&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports